__turbopack_context__.v({
  "address": "TokenTransfersPage-module__VOslyG__address",
  "age": "TokenTransfersPage-module__VOslyG__age",
  "amount": "TokenTransfersPage-module__VOslyG__amount",
  "container": "TokenTransfersPage-module__VOslyG__container",
  "emptyState": "TokenTransfersPage-module__VOslyG__emptyState",
  "filterButton": "TokenTransfersPage-module__VOslyG__filterButton",
  "header": "TokenTransfersPage-module__VOslyG__header",
  "link": "TokenTransfersPage-module__VOslyG__link",
  "method": "TokenTransfersPage-module__VOslyG__method",
  "pageButton": "TokenTransfersPage-module__VOslyG__pageButton",
  "pageButtonActive": "TokenTransfersPage-module__VOslyG__pageButtonActive",
  "pagination": "TokenTransfersPage-module__VOslyG__pagination",
  "pulse": "TokenTransfersPage-module__VOslyG__pulse",
  "skeleton": "TokenTransfersPage-module__VOslyG__skeleton",
  "table": "TokenTransfersPage-module__VOslyG__table",
  "tableContainer": "TokenTransfersPage-module__VOslyG__tableContainer",
  "title": "TokenTransfersPage-module__VOslyG__title",
  "tokenLink": "TokenTransfersPage-module__VOslyG__tokenLink",
});
